import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import {red } from '@mui/material/colors';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import InfoIcon from '@mui/icons-material/Info';

interface FinancialCardProps {
  typeofcast: string;
  title: string;
  timer: string;
  forecastValue: number;
  percentageChange: number;
}

const FinancialCard: React.FC<FinancialCardProps> = ({
  typeofcast,
  title,
  timer,
  forecastValue,
  percentageChange,
}) => {
  const formatValue = (value: number) => `$${value.toFixed(2)} M`;

  return (
    <Card variant="outlined" sx={{  background: 'white' }}>
      <CardContent>
        <Typography color="black" gutterBottom style={{display:'flex',fontWeight:'600',marginBottom:'0px',alignItems:'center',flexWrap:'wrap'}}>
          {typeofcast}
{/* <InfoIcon color="action" style={{paddingLeft:'5px',color:'#4040ab'}}/> */}
        </Typography>
        <Typography color="grey" style={{display:'flex',fontWeight:'300',fontSize:' 0.7rem'}}>{timer}</Typography>
        <Typography color="black" variant="h5" component="h2" gutterBottom style={{fontWeight:'300'}}>
          {title}
        </Typography>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h5" component="p" color="black" >
            {formatValue(forecastValue)}
          </Typography>
          <Box bgcolor={percentageChange<0?red[500]:'none'} borderRadius={16} px={2} py={0.45} >
            <Typography color="common.white" style={{fontSize:'0.9505rem'}}>{percentageChange.toFixed(1)}%</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

const ActualsCard: React.FC = () => (
  <Grid container spacing={2}>
    <Grid item xs={3}>
      <FinancialCard
        typeofcast="Actuals"
        title="OpEx"
        timer="YTD by March"
        forecastValue={4.15}
        percentageChange={-10.6}
      />
    </Grid>
    <Grid item xs={3}>
      <FinancialCard
        title="OpEx Forecast"
        typeofcast="Budget Forecast"
        timer="2024"
        forecastValue={11.26}
        percentageChange={0}
      />
    </Grid>
    <Grid item xs={3}>
      <FinancialCard
         typeofcast= 'Actuals'
         title= 'CapEx'
         timer= 'YTD by March'
         forecastValue= {3.19}
         percentageChange={-3.9}
      />
    </Grid>
    <Grid item xs={3}>
      <FinancialCard
       typeofcast= 'Budget Forecast'
       title= 'CapEx  Forecast'
       timer= '2024'
       forecastValue= {9.21}
       percentageChange= {0}
      />
    </Grid>
  </Grid>
);

export default ActualsCard;
